import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { Link } from "react-router-dom";

import logo from "logo_black.svg";

import { sendPasswordResetEmail } from "..";

type FormData = {
  email: string;
};

export const ForgottenPasswordPage = () => {
  const [hasSubmitted, setHasSubmitted] = useState(false);
  const { register, handleSubmit, errors } = useForm<FormData>();

  const onClickSubmit = handleSubmit(async ({ email }) => {
    sendPasswordResetEmail(email);
    setHasSubmitted(true);
  });

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="max-w-md w-full py-4 px-6">
        <img className="mx-auto h-20 w-auto my-8" src={logo} alt="" />
        <form
          className="bg-white rounded px-8 pt-6 pb-8 mb-4"
          noValidate
          onSubmit={onClickSubmit}
        >
          <div className="mb-8">
            <label
              className="block text-gray-700 text-sm font-bold mb-2"
              htmlFor="email"
            >
              Email address
            </label>
            <input
              name="email"
              id="email"
              type="email"
              ref={register({ required: true })}
              className={`${
                errors.email ? "border-red-500 " : ""
              } shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline`}
              placeholder="Email address"
            />
            {errors.email && (
              <p className="text-red-500 text-xs italic">
                Please enter a email.
              </p>
            )}
          </div>
          <div className="flex items-center justify-between">
            <input
              type="submit"
              value="Reset Password"
              className="bg-blue-500 cursor-pointer hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
            />
            <Link
              className="inline-block align-baseline font-bold text-sm text-blue-500 hover:text-blue-800"
              to={`/signin`}
            >
              Back to sign in
            </Link>
          </div>
          {hasSubmitted && (
            <p className="text-grey-900 text-xs italic mt-2">
              Please check your email. We have sent a password reset email.
            </p>
          )}
        </form>
      </div>
    </div>
  );
};
